import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';

import { createReducersMap } from 'redux/modules/reducer';

import { mainApi } from 'services/toolkit/main.service';
import tableReducer from './slices/tableSlice';

export const setupStore = (history: any) => {
  const rootReducer = combineReducers({
    ...createReducersMap(history), // все старые редьюсеры
    [mainApi.reducerPath]: mainApi.reducer,
    tableReducer,
  });

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false })
        .concat(thunk)
        .concat(routerMiddleware(history))
        .concat(mainApi.middleware),
    devTools: process.env.NODE_ENV !== 'production',
  });

  return store;
};

export type AppStore = ReturnType<typeof setupStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
